import { useRef, useCallback } from 'react';

export const useButtonProtection = (delay: number = 500) => {
  const lastClickTime = useRef<number>(0);
  const isProcessing = useRef<boolean>(false);

  const protectedClick = useCallback(
    (callback: (...args: unknown[]) => Promise<void> | void) => {
      return async (...args: unknown[]) => {
        const now = Date.now();
        
        // Prevent multiple clicks in a short period of time
        if (now - lastClickTime.current < delay) {
          return;
        }
        
        // Prevent clicks while processing
        if (isProcessing.current) {
          return;
        }
        
        lastClickTime.current = now;
        isProcessing.current = true;
        
        try {
          await callback(...args);
        } finally {
          isProcessing.current = false;
        }
      };
    },
    [delay]
  );

  return { protectedClick };
};